import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import React from 'react';
import PICTURE_PROCES_SINGE_OUTLINE_LIGHT_24 from '@tencent/docs-design-resources/icon/desktop/svg/pictureprocessinge_outline_light_24.svg';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { wrapIdForPic } from '@src/framework/workbench/util/wrap-id-util';
import { TOOLBAR_PICTURE_TOOLS_ICON } from '@src/framework/editor/src/img/pageIndex';

export const config = {
    id: ActionType.PIC_HANDLER,
    content: i18n.t('图片处理'),
};

export const toolbarConfig = {
    id: ActionType.PIC_HANDLE_TOOLBAR,
    content: i18n.t('图片处理'),
    icon: PICTURE_PROCES_SINGE_OUTLINE_LIGHT_24,
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_PIC_ADJUST,
        ver3: 1,
    },
};


export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        style: {
            cursor: 'default',
        },
        preventDismiss: true,
        preventHighlight: true,
    },
    {
        name: 'toolbar-efficiency-parent',
        content: i18n.t<string>('效率工具'),
    },
    {
        name: 'toolbar-picture-short-cut',
        content: i18n.t<string>('图片快捷'),
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={toolbarConfig.icon} />,
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
    },
    {
        name: wrapIdForPic(toolbarConfig.id),
        icon: <img src={TOOLBAR_PICTURE_TOOLS_ICON} />,
        text: i18n.t<string>('更多工具'),
        tooltip: i18n.t<string>('更多工具'),
        style: {
            width: 'auto',
        },
    },
];
